import { faAddressBook } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Box, CloseButton, Flex } from '@modusign/design-system';

import {
  WindowModal,
  WindowModalContent,
  WindowModalHeader,
} from '@app/components/Modal/WindowModal';
import ContactInputForm from '@app/features/addressBook/components/ContactInputForm';
import { CreateContactFormValue } from '@app/features/addressBook/types';

interface NewContactModalProps {
  isOpen: boolean;
  onClose: () => void;
  onSubmit: (contact: CreateContactFormValue) => void;
}
function NewContactModal({ isOpen, onClose, onSubmit }: NewContactModalProps) {
  return (
    <WindowModal isOpen={isOpen} maxWidth="md" onRequestClose={onClose}>
      <WindowModalHeader>
        <Flex alignItems="center" justifyContent="space-between">
          <Flex>
            <Box color="textNeutralLight">
              <FontAwesomeIcon icon={faAddressBook} />
            </Box>
            <Box color="textNeutralLight" ml={2}>
              새 연락처
            </Box>
          </Flex>
          <Box>
            <CloseButton onClick={onClose} />
          </Box>
        </Flex>
      </WindowModalHeader>
      <WindowModalContent>
        <ContactInputForm submitButtonText="추가" onCancel={onClose} onSubmit={onSubmit} />
      </WindowModalContent>
    </WindowModal>
  );
}

export default NewContactModal;
